import { createFileRoute } from '@tanstack/react-router'
import { AgentsPage } from '@/features/dashboard/AgentsPage'

/**
 * The full-page agents view — "Start jamming with an agent". A dashboard-family
 * full-page route (the Shell renders it with `hideWorkspace` + the slim nav
 * rail, see `_app.tsx`). The page-shaped loading skeleton lives inside
 * `AgentsPage` (its `isLoading` state), which keeps the header interactive while
 * the agent grid fills in.
 */
export const Route = createFileRoute('/_app/agents')({
  component: AgentsPage,
})
